import {getServerTexts as getTexts, initTexts, texts} from '../../../Localization/texts';

const entity = 'UI_TEMPLATE_REPORT';

const en = {
    download: 'Download and edit',
    preview: 'Preview',
    delete: 'Delete',
    upload: 'Upload file',
    duplicate: 'Duplicate',
    setReadOnly: 'Set as read only',
    setEditable: 'Set as Editable',
    uploadFileSucces: 'Upload complete',
    readOnly: 'Read only',
    uploadTemplate: 'Upload Word Template',
    cancel: 'Cancel',
    newTemplateMessageTitle: 'The Word Template has been downloaded to your computer',
    newTemplateMessageContent: 'When finished editing, upload it to the new template line',
    newTemplatetitle: 'New_Template',
    editMessagesContet: ' When finished editing it, upload to ',
    theFile: 'The file',
    uploaded: 'was uploaded',
    defaultTemplateDownload: 'After editing, upload the file to a new template that you created.',
    predefined: 'predefined template',
    payAttention: 'Note',
    languageChangeWarning:
        'The language is only a property and changing the language does not change the language of the file.',
    dontshowAgain: "Don't show me again",
    ok: 'OK'
};

const he = {
    download: ' הורדה ועריכה',
    preview: 'הצגה',
    delete: 'מחיקה',
    upload: 'העלאת קובץ ',
    duplicate: 'שכפול תבנית',
    setReadOnly: 'קבע כקריאה בלבד',
    setEditable: 'קבע כניתן לעריכה',
    uploadFileSucces: 'הקובץ החדש עלה',
    readOnly: 'לקריאה בלבד',
    uploadTemplate: 'העלאת קובץ',
    cancel: 'ביטול',
    newTemplateMessageTitle: 'טמפלט WORD ירד למחשב שלך',
    newTemplateMessageContent: 'בסיום העריכה יש להעלות אותו אל שורת הטמפלט החדש',
    newTemplatetitle: 'New_Template',
    editMessagesContet: ' בסיום עריכתו יש להעלות אותו אל',
    theFile: 'הקובץ',
    uploaded: 'עלה',
    defaultTemplateDownload: 'בסיום העריכה, יש להעלות את הקובץ לתבנית חדשה שיצרת.',
    predefined: 'תבנית מערכת',
    payAttention: 'כדאי לשים לב,',
    languageChangeWarning: 'שינוי הגדרת השפה לתבנית לא ישנה את שפת הטקסטים הכלוליםבתבנית.',
    dontshowAgain: 'לא להציג שוב',
    ok: 'אישור'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'download',
    2: 'preview',
    3: 'delete',
    4: 'upload',
    5: 'duplicate',
    6: 'setReadOnly',
    7: 'setEditable',
    8: 'uploadFileSucces',
    9: 'readOnly',
    10: 'uploadTemplate',
    11: 'cancel',
    12: 'newTemplateMessageTitle',
    13: 'newTemplateMessageContent',
    14: 'newTemplatetitle',
    15: 'editMessagesContet',
    16: 'theFile',
    17: 'uploaded',
    18: 'defaultTemplateDownload',
    19: 'predefined',
    20: 'payAttention',
    21: 'languageChangeWarning',
    22: 'dontshowAgain',
    23: 'ok'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
